import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import Button from '@adsk/bim360-matrix-react-button';
import ModalConfirmation from '@adsk/bim360-matrix-react-modal-confirmation';
import i18n from '../../../utils/i18n';

class IssueRootCausesAdminChangeStatusModal extends PureComponent {
  constructor(props) {
    super(props);

    this.onConfirm = this.onConfirm.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    this.props.onModalClose();
  }

  onConfirm() {
    this.props.onConfirm(this.props.data);
  }

  _renderModalMessage() {
    return (
      <p className="IssueRootCausesAdminChangeStatusModal_message">
        {i18n.t('issueRootCauses.modal.changeRootCauseStatusAlert')}
      </p>
    );
  }

  render() {
    return (
      <ModalConfirmation
        className="IssueRootCausesAdminChangeStatusModal"
        show={this.props.isOpen}
        onConfirm={this.onConfirm}
        title={i18n.t('issueRootCauses.modal.changeStatusTitle')}
        message={this._renderModalMessage()}
        onHide={this.closeModal}
        onExited={this.closeModal}
        container={this.props.container}
        hideOnConfirm
        confirmationButtonLabel={i18n.t('issueRootCauses.modal.change')}
        confirmationButtonStyleType={Button.StyleType.PRIMARY}
      />
    );
  }
}

IssueRootCausesAdminChangeStatusModal.displayName = 'IssueRootCausesAdminChangeStatusModal';

IssueRootCausesAdminChangeStatusModal.defaultProps = {
  data: {}
};

IssueRootCausesAdminChangeStatusModal.propTypes = {
  container: PropTypes.object.isRequired,
  isOpen: PropTypes.bool.isRequired,
  data: PropTypes.object,
  onConfirm: PropTypes.func.isRequired,
  onModalClose: PropTypes.func.isRequired
};

export default IssueRootCausesAdminChangeStatusModal;
